(function () {
  var config = window.TravelAvenueCrm || {};
  var endpoint = config.endpoint;

  if (!endpoint || !window.fetch) {
    return;
  }

  function value(form, selectors) {
    for (var i = 0; i < selectors.length; i += 1) {
      var field = form.querySelector(selectors[i]);
      if (field && field.value) {
        return field.value.trim();
      }
    }
    return "";
  }

  function dataValue(form, name) {
    if (!form.dataset) return "";
    return form.dataset[name] || "";
  }

  function allText(form) {
    return Array.prototype.slice.call(form.querySelectorAll("input, textarea, select"))
      .map(function (field) {
        return [field.name, field.value].filter(Boolean).join(" ");
      })
      .join(" ")
      .toLowerCase();
  }

  function inferIntent(form) {
    if (dataValue(form, "taCrmIntent")) return dataValue(form, "taCrmIntent");
    var text = allText(form);
    if (text.indexOf("back in stock") !== -1 || text.indexOf("notify me") !== -1 || text.indexOf("stock alert") !== -1) return "back_in_stock";
    if (text.indexOf("warranty") !== -1) return "warranty";
    if (text.indexOf("return") !== -1 || text.indexOf("refund") !== -1 || text.indexOf("exchange") !== -1) return "support";
    if (text.indexOf("bulk") !== -1 || text.indexOf("b2b") !== -1 || text.indexOf("corporate") !== -1 || text.indexOf("wholesale") !== -1 || text.indexOf("quote") !== -1) return "b2b";
    if (text.indexOf("newsletter") !== -1 || text.indexOf("notify") !== -1) return "newsletter";
    if (config.productTitle) return "product_question";
    return "contact";
  }

  function formType(form) {
    if (dataValue(form, "taCrmFormType")) return dataValue(form, "taCrmFormType");
    var text = allText(form);
    if (text.indexOf("back in stock") !== -1 || text.indexOf("notify me") !== -1 || text.indexOf("stock alert") !== -1) return "back_in_stock";
    if (text.indexOf("newsletter") !== -1) return "newsletter";
    if (form.getAttribute("action") && form.getAttribute("action").indexOf("/contact") !== -1) return "contact";
    return "website_form";
  }

  function isTrackedForm(form) {
    if (form.hasAttribute("data-ta-crm-form")) return true;
    if (form.querySelector('[name^="contact["]') || form.querySelector('[name^="customer["]')) return true;
    var marker = [
      form.getAttribute("id"),
      form.getAttribute("class"),
      form.getAttribute("action"),
      form.getAttribute("aria-label"),
      allText(form)
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();
    return marker.indexOf("back-in-stock") !== -1 ||
      marker.indexOf("back in stock") !== -1 ||
      marker.indexOf("stock alert") !== -1 ||
      marker.indexOf("notify-me") !== -1 ||
      marker.indexOf("notify me") !== -1;
  }

  function setFormStatus(form, message) {
    var status = form.querySelector("[data-ta-crm-status]");
    if (status) {
      status.textContent = message;
      status.hidden = false;
    }
  }

  function payloadFromForm(form) {
    var name = value(form, ['[name="contact[name]"]', '[name="customer[name]"]', '[name="name"]']);
    var message = value(form, ['[name="contact[body]"]', '[name="contact[Message]"]', '[name="message"]', "textarea"]);
    var productTitle = config.productTitle || value(form, ['[name="contact[Product]"]', '[name="product_title"]']);

    return {
      source: dataValue(form, "taCrmSource") || "shopify_theme",
      intent: inferIntent(form),
      formType: formType(form),
      name: name,
      email: value(form, ['[name="contact[email]"]', '[name="customer[email]"]', '[name="email"]', '[type="email"]']),
      phone: value(form, ['[name="contact[phone]"]', '[name="contact[Phone]"]', '[name="phone"]', '[type="tel"]']),
      companyName: value(form, ['[name="contact[Company]"]', '[name="contact[Company name]"]', '[name="company"]']),
      message: message,
      productInterest: productTitle || value(form, ['[name="contact[Product interest]"]']),
      preferredBrand: config.productVendor || value(form, ['[name="contact[Brand]"]']),
      pageUrl: window.location.href,
      pageTitle: document.title,
      productTitle: productTitle,
      productHandle: config.productHandle || "",
      orderNumber: value(form, ['[name="contact[Order number]"]', '[name="contact[Order]"]', '[name="order_number"]']),
      supportChannel: value(form, ['[name="contact[Support channel]"]', '[name="support_channel"]']) || "website",
      caseType: value(form, ['[name="contact[Reason]"]', '[name="contact[Case type]"]', '[name="case_type"]']),
      issueType: value(form, ['[name="contact[Issue type]"]', '[name="issue_type"]']),
      requestedResolution: value(form, ['[name="contact[Preferred resolution]"]', '[name="requested_resolution"]', '[name="resolution"]']),
      priority: value(form, ['[name="contact[Priority]"]', '[name="priority"]']),
      consent: true
    };
  }

  function send(payload) {
    if (!payload.email && !payload.phone) {
      return;
    }

    return window.fetch(endpoint, {
      method: "POST",
      mode: "cors",
      credentials: "omit",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload),
      keepalive: true
    }).catch(function () {});
  }

  document.addEventListener(
    "submit",
    function (event) {
      var form = event.target;
      if (!form || !form.querySelector) return;
      if (!isTrackedForm(form)) return;
      if (form.hasAttribute("data-ta-crm-form")) {
        event.preventDefault();
        setFormStatus(form, "Thanks, we received this and will follow up.");
      }
      send(payloadFromForm(form));
    },
    true
  );

  if (config.customerEmail && config.productTitle) {
    window.setTimeout(function () {
      send({
        source: "shopify_theme",
        intent: "high_intent_product_view",
        eventType: "high_intent_product_view",
        name: config.customerName || "",
        email: config.customerEmail,
        phone: config.customerPhone || "",
        productInterest: config.productTitle,
        preferredBrand: config.productVendor || "",
        pageUrl: window.location.href,
        pageTitle: document.title,
        productTitle: config.productTitle,
        productHandle: config.productHandle || "",
        consent: true
      });
    }, 60000);
  }
})();
